import { render } from "./ContentLoader.vue?vue&type=template&id=44472d41"
import script from "./ContentLoader.vue?vue&type=script&lang=js"
export * from "./ContentLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__